// import './wdyr';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import * as Sentry from '@sentry/browser';
import { Amplify } from 'aws-amplify';
import { CategoryScale, Chart, LinearScale, LineElement, registerables, TimeScale } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { render } from 'react-dom';
import TagManager from 'react-gtm-module';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { AuthProvider } from './app/AuthProvider';
import { RestfulReactProvider } from './app/RestfulReactProvider';
import { Navigation } from './components/Navigation';
import { aws, gtm, sentry } from './config';
import { NavigationProvider, Theme } from './design-system';
import { setUpStore } from './store/configure';
import { history } from './utils/history';
import Views from './views';

Sentry.init(sentry);

Amplify.configure(aws);

const store = setUpStore();

TagManager.initialize(gtm);

Chart.register(LineElement, zoomPlugin, CategoryScale, LinearScale, TimeScale, ...registerables);

const App = (
  <Provider store={store}>
    <Router history={history}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AuthProvider>
          <RestfulReactProvider store={store}>
            <Theme>
              <SnackbarProvider maxSnack={3} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                <Helmet defaultTitle="Evnex CP-Link" titleTemplate="%s · Evnex CP-Link" />
                <NavigationProvider>
                  <Navigation>
                    <Views />
                  </Navigation>
                </NavigationProvider>
              </SnackbarProvider>
            </Theme>
          </RestfulReactProvider>
        </AuthProvider>
      </LocalizationProvider>
    </Router>
  </Provider>
);
render(App, document.getElementById('root'));
export { sortConnectors } from './utils/chargePoints/connectors';
